const FormExpiryReason = [
  { value: 1, name: 'Natural', description: 'Natural Expiration' },
  { value: 2, name: 'Replaced', description: 'Form Replaced' },
  { value: 3, name: 'ExpiredInternationalOrganisation', description: 'No Longer a Valid International Organisation' },
  { value: 4, name: 'AuditorsLetter', description: "Auditor's Letter" },
  { value: 5, name: 'OwnerReportingStatement', description: 'Owner Reporting Statement' },
  { value: 6, name: 'UsTinAppliedFor', description: 'U.S. TIN Applied For' },
  { value: 7, name: 'GiinAppliedFor', description: 'GIIN Applied For' },
  { value: 8, name: 'GiinNotFound', description: 'GIIN Not Present on IRS FFI GIIN List' },
  { value: 9, name: 'Bankruptcy', description: 'Bankruptcy Expiration' },
  { value: 10, name: 'SicCodeChange', description: 'NFFE is Now Engaging in the Business of a Financial Institution' },
  { value: 11, name: 'ExceptedStartupCompany', description: 'Startup Excepted NFFE Status Expiry' },
  { value: 12, name: 'GiinExpired', description: 'GIIN removed from IRS FFI GIIN List' },
  { value: 13, name: 'InvalidInternationalOrganisation', description: 'Not a Valid International Organisation' },
  { value: 14, name: 'CuredCic', description: 'Cured CIC' },
  { value: 15, name: 'UnCuredCic', description: 'Uncured CIC' },
  { value: 16, name: 'TreatyTerminated', description: 'Treaty Terminated' },
  { value: 9999, name: 'PriorDetermination', description: 'Prior Determination' }
];

FormExpiryReason.findByName = (reasonName) => {
  if (!reasonName || reasonName.length <= 0) {
    return null;
  }

  const reason = FormExpiryReason.find(x => x.name.toLowerCase() === reasonName.toLowerCase());
  return reason || null;
};

export default FormExpiryReason;
